export default function shipping(){
    return(
        <div>

            Shipping & Delivery Policy
JobSniper is a digital service, and no physical goods are shipped.
All services, including resume analysis and flow generation, are delivered online and instantly after successful payment.

Delivery Time:
Access to premium features is provided immediately once the payment is confirmed.

Shipping Charges:
There are no shipping or delivery charges, as no physical product is sent.

Mode of Delivery:
Delivery is done digitally through the JobSniper web platform.

For any issues related to delivery of digital access, please contact us at jobsniperteam@gmail.com

.
</div>
    )
}